import { chakra } from '@chakra-ui/react';
import { useMemo } from 'react';
import {
  Coordinate2Result,
  Point2,
} from '../../../domain/geometry/geometric-types';

type Coordinate2ResultVisualizationProps = {
  result: Coordinate2Result;
  getPointInDomCoordinateSystem: (pointInPdf: Point2) => Point2;
};

export const Coordinate2ResultVisualization = ({
  result,
  getPointInDomCoordinateSystem,
}: Coordinate2ResultVisualizationProps) => {
  const pointInDom = useMemo<Point2>(
    () => getPointInDomCoordinateSystem(result.point),
    [getPointInDomCoordinateSystem, result.point]
  );

  return (
    <chakra.svg
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="100%"
      opacity={0.7}
    >
      <chakra.circle
        cx={pointInDom[0]}
        cy={pointInDom[1]}
        r="5"
        fill={'teal.400'}
      />
    </chakra.svg>
  );
};
